import api from './api';

const blindboxService = {
  /**
   * 获取所有盲盒列表
   */
  getBlindBoxList: async () => {
    const response = await api.get('/blindbox/list');
    return response.data;
  },

  /**
   * 获取某个盲盒包含的礼物列表
   */
  getBlindBoxGifts: async (blindBoxName) => {
    const response = await api.get(`/blindbox/gifts/${encodeURIComponent(blindBoxName)}`);
    return response.data;
  },

  /**
   * 获取盲盒统计数据
   */
  getBlindBoxStats: async (roomId, blindGiftName = null) => {
    const params = blindGiftName ? { blindGiftName } : {};
    const response = await api.get(`/blindbox/stats/${roomId}`, { params });
    return response.data;
  },

  /**
   * 清空盲盒统计
   */
  clearBlindBoxStats: async (roomId, blindGiftName = null) => {
    const response = await api.post(`/blindbox/stats/${roomId}/clear`, { blindGiftName });
    return response.data;
  },

  /**
   * 获取盲盒统计配置
   */
  getBlindBoxConfig: async (roomId) => {
    const response = await api.get(`/blindbox/config/${roomId}`);
    return response.data;
  },

  /**
   * 保存盲盒统计配置
   */
  saveBlindBoxConfig: async (roomId, config) => {
    const response = await api.put(`/blindbox/config/${roomId}`, config);
    return response.data;
  },

  /**
   * 获取房间的 OBS 访问令牌
   */
  getAccessToken: async (roomId) => {
    const response = await api.get(`/blindbox/token/${roomId}`);
    return response.data;
  },

  /**
   * 重新生成房间的 OBS 访问令牌
   */
  regenerateAccessToken: async (roomId) => {
    const response = await api.post(`/blindbox/token/${roomId}/regenerate`);
    return response.data;
  }
};

export default blindboxService;
